export default __webpack_public_path__ + "static/media/header-male.4f5f98ca.jpg";